import React, { useState } from "react";

export const PainHistory2 = ({
  setPatientMedicationInfo,
  patientMedicationInfo,
}) => {
  const [painHistory, setPainHistory] = useState({
    walkingLimited: "",
    therapyHelp: "",
    exercisesName: "",
    SurgicalHistory: "",
  });
  return (
    <>
      <div className="flex flex-col justify-start items-start gap-4 mb-5 bg-white rounded shadow-sm p-5">
        <div>
          <h3 className="text-[#333333] font-mainFont font-[600] 2xl:text-[1.3vw] xl:text-[1.3vw] lg:text-[1.3vw] md:text-[2.3vw] text-[3.5vw]">
            Physical therapy Details
          </h3>
        </div>

        <div className="flex flex-col 2xl:flex-row xl:flex-row lg:flex-row md:flex-col gap-4">
          <div className="my-2 flex flex-col gap-4 bg-whit p-6 border border-[#d4d4d4] w-full">
            <p className="font-mainFont font-[400] text-white 2xl:text-[1.3vw] xl:text-[1.3vw] lg:text-[1.3vw] md:text-[2.3vw] text-[3.5vw]">
              Is your walking limited due to pain?
            </p>
            <div className="flex justify-start items-center gap-4">
              <button
                onClick={() => {
                  setPainHistory({
                    ...painHistory,
                    walkingLimited: "Yes",
                  });
                  setPatientMedicationInfo({
                    ...patientMedicationInfo,
                    limitedForPain: "Yes",
                  });
                }}
                className={`text-[#333333]   px-8 py-1 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-mainFont font-[500] rounded-full transition-all duration-200 ease-linear shadowsForMainWrapper ${
                  patientMedicationInfo.limitedForPain === "Yes"
                    ? "text-white BTNGradientBg"
                    : "text-black bg-white"
                }`}
              >
                Yes
              </button>
              <button
                onClick={() => {
                  setPainHistory({
                    ...painHistory,
                    walkingLimited: "No",
                  });
                  setPatientMedicationInfo({
                    ...patientMedicationInfo,
                    limitedForPain: "No",
                  });
                }}
                className={`text-[#333333] px-8 py-1 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-mainFont font-[500] rounded-full  transition-all duration-200 ease-linear shadowsForMainWrapper ${
                  patientMedicationInfo.limitedForPain === "No"
                    ? "text-white BTNGradientBg"
                    : "text-black bg-white"
                }`}
              >
                No
              </button>
            </div>
          </div>

          <div className="my-2 flex flex-col gap-4 p-6 bg-whit  border border-[#d4d4d4] w-full">
            <p className="font-mainFont font-[400] 2xl:text-[1.3vw] xl:text-[1.3vw] lg:text-[1.3vw] md:text-[2.3vw] text-[3.5vw] text-white">
              Did this therapy help?
            </p>
            <div className="flex justify-start items-center gap-4">
              <button
                onClick={() => {
                  setPainHistory({
                    ...painHistory,
                    therapyHelp: "Yes",
                  });
                  setPatientMedicationInfo({
                    ...patientMedicationInfo,
                    isTherapyhelp: "Yes",
                  });
                }}
                className={`text-[#333333]   px-8 py-1 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-mainFont font-[500] rounded-full  transition-all duration-200 ease-linear shadowsForMainWrapper ${
                  patientMedicationInfo.isTherapyhelp === "Yes"
                    ? "text-white BTNGradientBg"
                    : "text-black bg-white"
                }`}
              >
                Yes
              </button>
              <button
                onClick={() => {
                  setPainHistory({
                    ...painHistory,
                    therapyHelp: "No",
                  });
                  setPatientMedicationInfo({
                    ...patientMedicationInfo,
                    isTherapyhelp: "No",
                  });
                }}
                className={`text-[#333333]  px-8 py-1 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-mainFont font-[500] rounded-full  transition-all duration-200 ease-linear shadowsForMainWrapper ${
                  patientMedicationInfo.isTherapyhelp === "No"
                    ? "text-white BTNGradientBg"
                    : "text-black bg-white"
                }`}
              >
                No
              </button>
            </div>
          </div>
        </div>

        <div className="my-2 flex flex-col gap-4 border-b border-[#d4d4d4] py-10">
          <p className="font-mainFont font-[400]  2xl:text-[1.3vw] xl:text-[1.3vw] lg:text-[1.3vw] md:text-[2.3vw] text-[3.5vw] text-white">
            Do you do any special exercises for your back or neck?
          </p>
          <div className="flex justify-start items-center gap-4">
            <input
              className="w-full border border-[#d4d4d4] bg-[#f0f0f0] px-5 py-3 rounded-full outline-none 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-[400] font-mainFont  text-[#333333] placeholder:text-[#333333]"
              placeholder="Enter Therapy"
              onChange={(e) => {
                setPatientMedicationInfo({
                  ...patientMedicationInfo,
                  specialExercisesName: e.target.value,
                });
              }}
              value={patientMedicationInfo.specialExercisesName}
            />
          </div>
        </div>

        <div className="my-2 flex flex-col gap-4 p-6 bg-whit border border-[#d4d4d4]">
          <p className="font-mainFont font-[400] 2xl:text-[1.1vw] xl:text-[1.1vw] lg:text-[1.1vw] md:text-[2.3vw] text-[3.5vw] text-white">
            PAST SURGICAL HISTORY
          </p>
          <div className="flex justify-start items-center gap-4">
            <button
              onClick={() => {
                setPainHistory({
                  ...painHistory,
                  SurgicalHistory: "Yes",
                });
                // Preserve existing explanation if any, otherwise set to "Yes"
                const currentValue = patientMedicationInfo.pastSurgicalHistory || "";
                if (currentValue.startsWith("Yes:")) {
                  // Keep existing explanation
                  setPatientMedicationInfo({
                    ...patientMedicationInfo,
                    pastSurgicalHistory: currentValue,
                  });
                } else {
                  setPatientMedicationInfo({
                    ...patientMedicationInfo,
                    pastSurgicalHistory: "Yes",
                  });
                }
              }}
              className={`text-[#333333]   px-8 py-1 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-mainFont font-[500] rounded-full  transition-all duration-200 ease-linear shadowsForMainWrapper ${
                patientMedicationInfo.pastSurgicalHistory?.startsWith("Yes") || patientMedicationInfo.pastSurgicalHistory === "Yes"
                  ? "text-white BTNGradientBg"
                  : "text-black bg-white"
              }`}
            >
              Yes
            </button>
            <button
              onClick={() => {
                setPainHistory({
                  ...painHistory,
                  SurgicalHistory: "No",
                });
                setPatientMedicationInfo({
                  ...patientMedicationInfo,
                  pastSurgicalHistory: "No",
                });
              }}
              className={`text-[#333333]   px-8 py-1 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-mainFont font-[500] rounded-full  transition-all duration-200 ease-linear shadowsForMainWrapper ${
                patientMedicationInfo.pastSurgicalHistory === "No"
                  ? "text-white BTNGradientBg"
                  : "text-black bg-white"
              }`}
            >
              No
            </button>
          </div>
          
          {/* Text input field - Show when "Yes" is selected */}
          {(patientMedicationInfo.pastSurgicalHistory?.startsWith("Yes") || patientMedicationInfo.pastSurgicalHistory === "Yes") && (
            <div className="mt-4">
              <input
                type="text"
                className="w-full border border-[#d4d4d4] bg-[#f0f0f0] px-5 py-3 rounded-full outline-none 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-[400] font-mainFont text-[#333333] placeholder:text-[#333333]"
                placeholder="Please explain your past surgical history..."
                value={
                  patientMedicationInfo.pastSurgicalHistory?.startsWith("Yes:")
                    ? patientMedicationInfo.pastSurgicalHistory.replace(/^Yes:\s*/, "")
                    : ""
                }
                onChange={(e) => {
                  const text = e.target.value.trim();
                  if (text) {
                    setPatientMedicationInfo({
                      ...patientMedicationInfo,
                      pastSurgicalHistory: `Yes: ${text}`,
                    });
                  } else {
                    setPatientMedicationInfo({
                      ...patientMedicationInfo,
                      pastSurgicalHistory: "Yes",
                    });
                  }
                }}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};
